/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Contract_OnInputs */



/**
* | output |
* | --- |
* | "Usage can continue after the prepaid budget is used up. That extra usage is charged separately by your partner." |
*
* @param {Usage_Overage_Contract_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_contract_on = /** @type {((inputs?: Usage_Overage_Contract_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Contract_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Nutzung kann nach Verbrauch des vorausbezahlten Budgets weitergehen. Diese zusätzliche Nutzung rechnet Ihr Partner separat ab.")
	return /** @type {LocalizedString} */ ("Usage can continue after the prepaid budget is used up. That extra usage is charged separately by your partner.")
});